export default "__VITE_ASSET__5f7303ad__"